"use strict";

define('components/maps',['markerclusterer'], function(MarkerClusterer) {

    var maps = {

        init: function () {
            var self = this;
            $('.map-container').each(function(){
                var mapNode = $(this);
                self.drawMap(mapNode);
            });
        },

        drawMap: function(mapNode) {
            var mapCanvas = mapNode.find('.map-canvas')[0];
            var mapOptions = {
                zoom: 12,
                scrollwheel: false,
            };
            if (mapCanvas) {
                var map = new google.maps.Map(mapCanvas, mapOptions);
                var isLightbox = mapNode.closest('.lightbox-body').length == 1;

                var resizeTimeout;
                var processResize = function (immediate) {
                    var desiredHeight;
                    if (mapNode.hasClass('map-full-height')) {
                        if (isLightbox) {
                            desiredHeight = $(window).height() - $('.lightbox-header').outerHeight();
                        } else {
                            desiredHeight = ($(window).height() -
                                            $('#footer').outerHeight() -
                                            mapNode.offset().top - 40);
                        }
                        if (desiredHeight < 320) {
                            desiredHeight = 320;
                        }
                    } else if (mapNode.data('desired-height')) {
                        desiredHeight = mapNode.data('desired-height');
                    } else {
                        desiredHeight = mapNode.width();
                    }

                    if(resizeTimeout) {
                        clearTimeout(resizeTimeout);
                    }

                    if(immediate) {
                        mapNode.height(desiredHeight);
                        google.maps.event.trigger(map, 'resize');
                    } else {
                        resizeTimeout = setTimeout(function () {
                            mapNode.height(desiredHeight);
                            google.maps.event.trigger(map, 'resize');
                        }, 250);
                    }
                };

                google.maps.event.addDomListener(window, 'resize', processResize);
                processResize(true);

                var infoWindow = new google.maps.InfoWindow({
                    maxWidth: 500
                });
                var marker = null;
                var markers = [];
                var bounds = new google.maps.LatLngBounds();
                var markerCount = mapNode.find('.location-data').length;
                mapNode.find('.location-data').each(function() {
                    var content;

                    var assetUrl = $(this).data('url');
                    var titleEscaped = $('<div></div>').text($(this).data('title')).html();
                    if (assetUrl) {
                        content = '<h4><a href="' + assetUrl + '">' + titleEscaped + '</a></h4>';
                    } else {
                        content = '<h4>' + titleEscaped + '</h4>';
                    }
                    if ($(this).data('address')) {
                        content += '<div>' + $(this).data('address') + '</div>';
                    }
                    content = '<div class="map-info-window-content">' + content;
                    if ($(this).data('caption')) {
                        content += '<div><em>' + $(this).data('caption') + '</em></div>';
                    }
                    if ($(this).data('date-sold')) {
                        content += '<div><em>Sold on ' + $(this).data('date-sold') + '</em></div>';
                    }
                    content += '</div>';

                    var coord = new google.maps.LatLng($(this).data('lat'), $(this).data('lng'));
                    var markerOptions = {
                        position: coord,
                        map: map,
                        title: $(this).data('title'),
                        zIndex: 1,
                    };
                    if ($(this).data('is-active') == 0 && markerCount > 1) {
                        markerOptions.zIndex = 0;
                        markerOptions.opacity = 0.5;
                    }
                    marker = new google.maps.Marker(markerOptions)
                    markers.push(marker);

                    var thisMarker = marker;
                    google.maps.event.addListener(marker, 'click', function() {
                        infoWindow.setContent(content);
                        infoWindow.open(map, thisMarker);
                    });

                    bounds.extend(marker.position);
                });
                if (markerCount > 1) {
                    var span = bounds.toSpan();
                    // If the bound spans more that 0.5 miles in either direction, set the zoom level
                    // 1 degree longitude 54.6 miles.  1 degree latitude = 69 miles)
                    if (span.lng() * 54.6 < .5 && span.lat() * 69 < 0.5) {
                        map.setZoom(13);
                        map.setCenter(marker.position);
                    } else {
                        map.fitBounds(bounds);
                    }

                    var clusterOptions = {
                        imagePath: '/static/markerclusterer/m',
                        gridSize: 30,
                        maxZoom: 13,
                        maxClickZoom: 15,
                        styles: [
                            {
                                height: 22,
                                width: 22,
                                borderWidth: 5,
                                textSize: 11,
                                backgroundColor: 'rgb(249, 91, 79)',
                                borderColor: 'rgba(249, 91, 79, 0.35)',
                            },
                            {
                                height: 30,
                                width: 30,
                                borderWidth: 5,
                                textSize: 13,
                                backgroundColor: 'rgb(249, 91, 79)',
                                borderColor: 'rgba(249, 91, 79, 0.35)',
                            },
                        ],
                    };
                    var markerCluster = new MarkerClusterer(map, markers, clusterOptions);

                } else {
                    map.setCenter(marker.position);
                }
            }
        }
    };

    return maps;
});

